import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAuthFromStorage } from 'shared/stored/Users/slice';
import { ACCESS_TOKEN, USER_PROFILE } from 'shared/constant';
import { USER_PROFILE_TYPE } from 'shared/types';

export const useAuthInit = () => {
  const dispatch = useDispatch();
  const userProfile = useSelector((state: any) => state.user?.profile);

  useEffect(() => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const userProfileStr = localStorage.getItem(USER_PROFILE);

    if (token && userProfileStr) {
      try {
        const userProfile: USER_PROFILE_TYPE = JSON.parse(userProfileStr);
        dispatch(setAuthFromStorage({
          authenticated: true,
          profile: userProfile
        }));
      } catch (error) {
        console.error('Error parsing user profile from localStorage:', error);
        // Clear invalid data
        localStorage.removeItem(USER_PROFILE);
        dispatch(setAuthFromStorage({
          authenticated: false
        }));
      }
    } else if (token && userProfileStr && !userProfile) {
      console.log('userProfileStr', userProfileStr);
      const userProfile: USER_PROFILE_TYPE = JSON.parse(userProfileStr);
      dispatch(setAuthFromStorage({
        authenticated: true,
        profile: userProfile
      }));
    } else if (!token) {
      // Only set authenticated false if no token
      dispatch(setAuthFromStorage({
        authenticated: false
      })); 
    }
  }, [dispatch]);
};

